module.exports = __webpack_public_path__ + "img/142.233e0af8.jpg";